import { useCallback } from 'react';

import type { LocationItem } from 'src/app/pages/search/shared/types';

import { useSearchForCountryName } from './hook/useSearchForCountries';
import { useSearchForRelevantCountries } from './hook/useSearchForRelevantCountries';

type Result = ModelHookResult<
	undefined,
	{
		searchForCountries: (queryLocation: string, selectedLocation: string) => Promise<readonly LocationItem[]>;
	}
>;

export function useLocationSearchCountries(): Result {
	const {
		actions: { searchForCountryName },
	} = useSearchForCountryName();

	const {
		actions: { searchForRelevantCountries },
	} = useSearchForRelevantCountries();

	return {
		actions: {
			searchForCountries: useCallback(
				async (queryLocation: string, selectedLocation: string) => {
					if (queryLocation) {
						return searchForCountryName(queryLocation, selectedLocation);
					}
					return searchForRelevantCountries(queryLocation, selectedLocation);
				},
				[searchForCountryName, searchForRelevantCountries],
			),
		},
	};
}
